export default __webpack_public_path__ + "static/media/twitter.7df99bf5.svg";